import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><path fillRule="nonzero" d="M9 16.107l.822.893L15 11.992 9.821 7l-.82.895 4.252 4.098z" /></svg>);